export default "__VITE_ASSET__DJWmPzv6__"